var index = {
    data() {
        return {
            list: [],
            loading: false
        }
    },
    fetch() {
        this.loading = true;
        this.$api.useraddress.select().then((res) => {
            this.loading = false;
            if (res.R) {
                this.list = res.data;
            }
        })
    }
}

export default index;